import { Navigate, Outlet, useLocation  } from 'react-router-dom'

import { useAuth } from '@/providers/AuthProvider'

import { LoadingScreen } from '@/components/common/LoadingScreen'
import type { UserRole } from '@/types/auth'

interface ProtectedRouteProps {
  redirectTo?: string
  requireRoles?: UserRole[]
}

export const ProtectedRoute = ({
  redirectTo = '/login',
  requireRoles,
}: ProtectedRouteProps) => {
  const location = useLocation()
  const { isAuthenticated, isLoading, hasRole } = useAuth()

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />
  }

  if (requireRoles && requireRoles.length > 0) {
    const allowed = hasRole(requireRoles)
    if (!allowed) {
      return <Navigate to="/dashboard" replace />
    }
  }

  return <Outlet />
}
